<div class="top-bar">
  <div class="top-bar-header">
    <span (click)="goBack()">
      <img class="h-18" src="assets/images/icon/chevronleft.svg" />
      {{ translations['back_label'] }}
    </span>
  </div>
  <div class="logo-div">
    <img
      src="assets/images/ecolab-logo-white-app-header.png"
      alt="EcoLab Logo"
      class="logo"
    />
  </div>
  <div class="content-end">
    <select
      [value]="currentLanguage"
      (change)="languageChange($event)"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option.value === currentLanguage"
      >
        {{ option.value }}
      </option>
    </select>
  </div>
</div>
<main class="grow overflow-hidden">
  <div class="h-full relative show-bottom-fade">
    <div class="h-full min-h-0 border-b border-white">
      <div class="max-w-xl mx-auto pt-2 px-4">
        <div class="w-full">
          <h1 class="h1">{{ translations['account_info_header'] }}</h1>
          <div class="account-info mb-3">
            <img
              src="../../../assets/images/icon/account-info.jpg"
              class="mx-2"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
